/*
  Klaviyo Reviews DOM shim.

  The design puts "Write a review" at the foot of the stats rail. Klaviyo renders it
  inside the reviews list, two levels below the only element the theme can make a grid
  container, so no amount of CSS can place it in the other column — the node has to
  move. Everything else about the widget is styled in assets/klaviyo-reviews.css.

  Same arrangement as assets/wishlist-page.js: the app owns the markup, the theme
  corrects one behaviour and leaves the rest alone.
*/
(() => {
  const MOUNT = '#fulfilled-reviews-all';
  const SUMMARY = '.kl_reviews__summary';
  const BUTTON_BAR = '.kl_reviews__button_bar';

  // The widget re-renders its list on sort, filter and "show more", which puts a fresh
  // button bar back in the list each time, so this runs on every mutation and is a
  // no-op once the bar is already in the rail.
  function relocate(root) {
    const summary = root.querySelector(SUMMARY);
    const bar = root.querySelector(BUTTON_BAR);
    if (!summary || !bar || bar.parentElement === summary) return;
    summary.appendChild(bar);
  }

  function start() {
    const mount = document.querySelector(MOUNT);
    if (!mount) return;

    relocate(mount);

    // Mounted asynchronously by Klaviyo's bundle, so the observer is the primary path
    // and the call above only covers a widget that is already up.
    new MutationObserver(() => relocate(mount)).observe(mount, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
